import { render, staticRenderFns } from "./FormSms.vue?vue&type=template&id=7158d39c"
import script from "./FormSms.vue?vue&type=script&lang=js"
export * from "./FormSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports